<template>
    <hts-drawer
        v-model="visible"
        :rules="rules"
        :submit="handleSubmit"
        :title="$t('labels.editApiKey')"
        @close="close">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-input
                v-model="form.name"
                :label="$t('labels.name')"
                required
                name="name"
                prop="name" />

            <hts-form-ip
                v-model="form.allowedIps"
                :label="$t('labels.allowedIps')" />
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
const { $t } = useNuxtApp()

const visible = ref(false)

const emits = defineEmits(['close', 'refreshTables', 'newPartner'])

const close = () => {
  visible.value = false
  reset()
}

const form = ref({
  name: '',
  allowedIps: [] as string[]
})
const idConnenct = ref('')

const open = (id: string, data: any) => {
  const { name, allowedIps } = data || {}

  idConnenct.value = id
  form.value.name = name || ''
  form.value.allowedIps = allowedIps || []
  visible.value = true
}
defineExpose({
  open
})

const reset = () => {
  form.value.name = ''
  form.value.allowedIps = []
}

const handleSubmit = () => {
  const api = $url.company.api_key.edit

  $api(api, { body: { name: form.value.name, allowedIps: form.value.allowedIps }, uriParams: { ID: idConnenct.value } }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      process.client && $toast().success('Chỉnh sửa api key thành công')
      emits('refreshTables')
      close()
    }
  })
}

const rules = computed(() => {
  return {
    name: 'required'
  }
})
</script>
